import { defineMessages } from 'react-intl'

// Shared by the post-signup VerifyDomainCard (E4 F4-6 / WI 508). Ids kept under the original
// dashboard.verifyDomainBanner.* namespace for i18n continuity with the E3 banner this replaces.
export default defineMessages({
  verifyDomainBannerBody: {
    id: 'dashboard.verifyDomainBanner.body',
    defaultMessage:
      'Verify a domain to enable single sign-on (SSO) and enterprise directory sync for your tenant.',
  },
  verifyDomainCta: {
    id: 'dashboard.verifyDomainBanner.cta',
    defaultMessage: 'Verify domain',
  },
})
